import { Pipe, PipeTransform } from '@angular/core';
import { SignHelper } from '../helpers/sign-helper';

@Pipe({
  name: 'stockSignMeasurements'
})
export class StockSignMeasurementsPipe implements PipeTransform {
  transform(
    signMeasurementsWidth: number,
    signMeasurementsHeight: number,
    signShapeIsUpright: boolean,
    withSpaces = true,
    showLeftUnit = true,
    showRightUnit = true
  ) {
    return SignHelper.getSignOrientationDisplayPipeable(
      signMeasurementsWidth,
      signMeasurementsHeight,
      signShapeIsUpright,
      withSpaces,
      showLeftUnit,
      showRightUnit
    );
  }
}
